import type { ThemeRequest, ThemeResponse } from "@/models/themes.model"
import type { HttpClient } from "@/services/http-common"
import { mapThemeResponseToTheme } from "@/mappers/theme.mapper"
import ApiServiceFactory from "@/services/api-service-factory"

export class ThemeService {
  private httpClient: HttpClient
  private readonly baseUrl: string = "/themes"

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  async fetchThemes() {
    const response = await this.httpClient.get<ThemeResponse[]>(`${this.baseUrl}/`)
    console.log("ThemeService.fetchThemes", response)
    return response.map(mapThemeResponseToTheme)
  }

  async createTheme(theme: ThemeRequest) {
    const response = await this.httpClient.post<ThemeResponse>(`${this.baseUrl}/`, theme)
    console.log("ThemeService.createTheme", response)
    return response
  }

  async updateTheme(theme: ThemeResponse) {
    const response = await this.httpClient.put<ThemeResponse>(`${this.baseUrl}/${theme.id}`, theme)
    console.log("ThemeService.updateTheme", response)
    return response
  }

  async deleteTheme(id: string) {
    const response = await this.httpClient.delete<ThemeResponse>(`${this.baseUrl}/${id}`)
    console.log("ThemeService.deleteTheme", response)
    return response
  }
}

export const themeService = ApiServiceFactory.createService(ThemeService, "theme")
export default ThemeService
